const { Mixin } = require('hops-mixin');
const ReduxThunkMiddleware = require('redux-thunk').default;

class HopsReduxRuntimeMixin extends Mixin {
  constructor(config, element, { redux: options = {} } = {}) {
    super(config);
    this.middlewares = options.middlewares || [];
  }

  getReduxMiddlewares() {
    const { config, fetch, fetchJson } = this;

    return [
      ...this.middlewares,
      ReduxThunkMiddleware.withExtraArgument({
        fetch,
        fetchJson,
        config,
      }),
    ];
  }
}

module.exports = HopsReduxRuntimeMixin;
